import React from "react";
import { format, parseISO } from "date-fns";
import { pl } from "date-fns/locale";
import { MdArrowBack, MdCheckCircle, MdCancel } from "react-icons/md";
import { TbShoppingCartPlus } from "react-icons/tb";
import EAButton from "../../../../shared/Buttons/EAButton";
import EAAlert from "../../../../shared/EAAlert";
import { KarnetTerm } from "./useKarnetSchedule";
import "./KarnetSection.scss";

interface IProps {
  terms: KarnetTerm[];
  availableCount: number;
  unavailableCount: number;
  totalPrice: number;
  isAdding: boolean;
  addError: string;
  onConfirm: () => void;
  onBack: () => void;
  /** "flow" = wygląd ścieżki zakupu w sprzedaży kalendarzowej (kafelki terminów, podsumowanie w ramce). */
  variant?: "default" | "flow";
}

const KarnetTermsConfirmation: React.FC<IProps> = ({
  terms,
  availableCount,
  unavailableCount,
  totalPrice,
  isAdding,
  addError,
  onConfirm,
  onBack,
  variant = "default",
}) => {
  return (
    <div className={`karnet-confirmation${variant === "flow" ? " karnet-confirmation--flow" : ""}`}>
      <p className="karnet-confirmation__lead">
        Sprawdź listę terminów, zanim potwierdzisz zakup — każdy z nich to osobna rezerwacja tego samego zestawu
        biletów.
      </p>

      {addError && <EAAlert type="error" message={addError} />}

      <div className="karnet-confirmation__list">
        {terms.map((term) => (
          <div key={term.index} className={`karnet-term karnet-term--${term.status}`}>
            <span className="karnet-term__index">#{term.index}</span>
            <span className="karnet-term__date">
              {format(parseISO(term.date), "EEEE, dd.MM.yyyy", { locale: pl })}
            </span>
            <span className="karnet-term__time">{term.startTimeLabel}</span>
            <span className="karnet-term__status">
              {term.status === "available" ? (
                <>
                  <MdCheckCircle /> Dostępny
                </>
              ) : (
                <>
                  <MdCancel /> Brak miejsc
                </>
              )}
            </span>
          </div>
        ))}
      </div>

      {unavailableCount > 0 && (
        <EAAlert
          type="warning"
          message={`${unavailableCount} ${
            unavailableCount === 1 ? "termin nie przejdzie" : "terminy nie przejdą"
          } do koszyka — brak miejsc. Do koszyka trafi ${availableCount} z ${terms.length} terminów.`}
        />
      )}

      <div className="karnet-confirmation__footer">
        <div className="karnet-confirmation__total">
          {variant === "flow" ? "Razem" : "Suma:"} <strong>{totalPrice.toFixed(2)} zł</strong>
        </div>
        <EAButton
          title="Dodaj do koszyka"
          onClick={onConfirm}
          endIcon={<TbShoppingCartPlus />}
          variant="filled"
          color="primary"
          fullWidth
          loading={isAdding}
          disabled={availableCount === 0}
          animationType="addToBasket"
        />
        <EAButton
          title="Powrót"
          onClick={onBack}
          startIcon={<MdArrowBack />}
          variant={variant === "flow" ? "outlined" : "text"}
          fullWidth
        />
      </div>
    </div>
  );
};

export default KarnetTermsConfirmation;
